import { apiClient } from '../../../gateways/api'

export { openKlantBijlage }

const openKlantBijlage = async ({
  id,
  bijlageId,
}: {
  id: string
  bijlageId: string
}) => {
  const { data } = await apiClient({
    url: `/rest/project/${id}/klantbijlage/${bijlageId}`,
    method: 'GET',
  })

  const { url } = data.downloadData

  window.open(url, '_blank')
}
